(() => {
  'use strict';
  if (window.oraguliCollectionGallery) return;
  const hover = matchMedia('(hover: hover) and (pointer: fine)');
  const popup = document.createElement('div');
  popup.className = 'collection-preview'; popup.setAttribute('popover', 'manual'); popup.setAttribute('role', 'region');
  const large = document.createElement('img'); large.alt = '';
  const viewer = document.createElement('button'); viewer.type = 'button'; viewer.className = 'collection-preview__viewer'; viewer.setAttribute('aria-pressed', 'false');
  viewer.append(large);
  const close = document.createElement('button'); close.type = 'button'; close.className = 'collection-preview__close';
  close.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  const count = document.createElement('span'); count.className = 'collection-preview__count';
  const previous = document.createElement('button'); previous.type = 'button'; previous.className = 'collection-preview__prev';
  const next = document.createElement('button'); next.type = 'button'; next.className = 'collection-preview__next';
  const arrow = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6"/></svg>';
  previous.innerHTML = arrow; next.innerHTML = arrow;
  popup.append(viewer, previous, next, close, count); document.body.append(popup);
  let active = null, showTimer, hideTimer, source = '', restore = null;
  let zoomed = false, touchStart = null, dragged = false;
  const resetZoom = () => {
    zoomed = false; touchStart = null;
    viewer.setAttribute('aria-pressed', 'false');
    large.style.transform = ''; popup.removeAttribute('data-zoomed');
  };
  const pan = e => {
    if (!zoomed) return;
    const rect = viewer.getBoundingClientRect();
    const px = e.detail === 0 && e.type === 'click' ? 0.5 : Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
    const py = e.detail === 0 && e.type === 'click' ? 0.5 : Math.max(0, Math.min(1, (e.clientY - rect.top) / rect.height));
    large.style.transform = `translate(${-3 * rect.width * px}px, ${-3 * rect.height * py}px) scale(4)`;
  };
  viewer.addEventListener('click', e => {
    if (dragged) { dragged = false; return; }
    if (large.hidden) return;
    if (zoomed) resetZoom();
    else { zoomed = true; viewer.setAttribute('aria-pressed', 'true'); popup.dataset.zoomed = 'true'; pan(e); }
  });
  viewer.addEventListener('pointermove', e => {
    if (e.pointerType === 'mouse') pan(e);
    else if (touchStart && zoomed) {
      if (Math.hypot(e.clientX - touchStart.x, e.clientY - touchStart.y) > 6) dragged = true;
      pan(e);
    }
  });
  viewer.addEventListener('pointerdown', e => {
    dragged = false;
    if (e.pointerType === 'touch' && zoomed) { touchStart = {x:e.clientX,y:e.clientY}; viewer.setPointerCapture(e.pointerId); }
  });
  viewer.addEventListener('pointerup', () => { touchStart = null; });
  viewer.addEventListener('pointercancel', () => { touchStart = null; dragged = false; });
  const hide = (restoreFocus = false) => {
    clearTimeout(showTimer); clearTimeout(hideTimer);
    if (popup.matches(':popover-open')) popup.hidePopover();
    popup.removeAttribute('data-open'); active = null;
    resetZoom();
    if (restoreFocus) restore?.focus();
    restore = null;
  };
  const scheduleHide = () => { clearTimeout(showTimer); hideTimer = setTimeout(() => hide(), 180); };
  const position = state => {
    const image = state.images[state.index];
    const rect = state.media.getBoundingClientRect();
    const margin = 12, gap = 14;
    const right = innerWidth - rect.right - gap - margin, left = rect.left - gap - margin;
    const room = Math.max(right, left);
    let width = Math.min(460, innerWidth - margin * 2, hover.matches && room > 260 ? room : innerWidth - margin * 2);
    const height = Math.min(innerHeight - margin * 2, width * image.height / image.width, 660);
    width = height * image.width / image.height;
    let x = hover.matches && room > 260 ? (right >= left ? rect.right + gap : rect.left - gap - width) : (innerWidth - width) / 2;
    const y = Math.max(margin, Math.min(innerHeight - height - margin, rect.top + rect.height / 2 - height / 2));
    x = Math.max(margin, Math.min(innerWidth - width - margin, x));
    Object.assign(popup.style, {left: `${x}px`, top: `${y}px`, width: `${width}px`, height: `${height}px`});
  };
  const show = state => {
    clearTimeout(showTimer); clearTimeout(hideTimer); active = state;
    resetZoom();
    const image = state.images[state.index];
    close.setAttribute('aria-label', state.card.dataset.closeLabel);
    previous.hidden = next.hidden = state.images.length < 2;
    previous.setAttribute('aria-label', state.card.querySelector('[data-card-prev]')?.getAttribute('aria-label') || 'Previous');
    next.setAttribute('aria-label', state.card.querySelector('[data-card-next]')?.getAttribute('aria-label') || 'Next');
    popup.setAttribute('aria-label', state.card.dataset.previewLabel);
    viewer.setAttribute('aria-label', state.card.dataset.previewLabel);
    count.textContent = state.images.length > 1 ? `${state.index + 1} / ${state.images.length}` : '';
    large.alt = image.alt;
    position(state);
    if (source !== image.large) {
      source = image.large; large.hidden = true; popup.setAttribute('aria-busy', 'true'); large.src = source;
    }
    popup.dataset.open = 'true';
    if (popup.showPopover && !popup.matches(':popover-open')) popup.showPopover();
    restore = state.card.querySelector('.card__photo-link');
  };
  large.addEventListener('load', () => { large.hidden = false; popup.removeAttribute('aria-busy'); });
  large.addEventListener('error', () => { source = ''; hide(); });
  popup.addEventListener('pointerenter', () => clearTimeout(hideTimer));
  popup.addEventListener('pointerleave', e => { if (hover.matches && e.pointerType === 'mouse') scheduleHide(); });
  close.addEventListener('click', () => hide(true));
  previous.addEventListener('click', () => active?.select(-1));
  next.addEventListener('click', () => active?.select(1));
  popup.addEventListener('keydown', e => {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); active?.select(e.key === 'ArrowLeft' ? -1 : 1); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') hide(true); });
  window.addEventListener('scroll', () => { if (hover.matches) hide(); }, {passive: true});
  window.addEventListener('resize', () => hide(), {passive: true});
  const init = (root = document) => {
    root.querySelectorAll('[data-card-gallery]').forEach(card => {
      if (card.__photoGallery) return;
      const data = JSON.parse(card.querySelector('[data-card-images]').textContent);
      const img = card.querySelector('.card__media img');
      if (!img || !data.images.length) return;
      const state = {card, images: data.images, index: Math.max(0, data.images.findIndex(image => image.id === data.initialId)), media: card.querySelector('.card__media-wrap')};
      card.__photoGallery = state;
      const label = card.querySelector('[data-card-count]');
      const updateCount = () => { if (label) label.textContent = `${state.index + 1} / ${state.images.length}`; };
      updateCount();
      const select = direction => {
        state.index = (state.index + direction + state.images.length) % state.images.length;
        const image = state.images[state.index];
        img.removeAttribute('srcset'); img.src = image.src; img.alt = image.alt;
        updateCount();
        if (active === state) show(state);
      };
      state.select = select;
      ['prev', 'next'].forEach(key => {
        const button = card.querySelector(`[data-card-${key}]`);
        button?.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); select(key === 'prev' ? -1 : 1); });
      });
      state.media.addEventListener('pointerenter', e => {
        if (!hover.matches || e.pointerType !== 'mouse') return;
        clearTimeout(hideTimer); clearTimeout(showTimer);
        showTimer = setTimeout(() => show(state), 220);
      });
      state.media.addEventListener('pointerleave', e => { if (hover.matches && e.pointerType === 'mouse') scheduleHide(); });
    });
  };
  window.oraguliCollectionGallery = {init, hide};
  init();
  document.addEventListener('shopify:section:load', e => { hide(); init(e.target); });
  document.addEventListener('shopify:section:unload', () => hide());
})();
